import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UseClientTripsNegotiations from "../../hooks/UseTripsNegotiations/UseClientTripsNegotiations";
import UseTravelerTripsNegotiations from "../../hooks/UseTripsNegotiations/UseTravelerTripsNegotiations";

const API_URL = process.env.REACT_APP_API_URL;

export default function KycComplete() {
  const navigate = useNavigate();

  const allowedStatuses = ["1", "2"];

  const {
    tripsNegotiations: tripsNegotiationsClient,
    loadingTripsNegotiations: loadingClient,
  } = UseClientTripsNegotiations();

  const {
    tripsNegotiations: tripsNegotiationsTraveler,
    loadingTripsNegotiations: loadingTraveler,
  } = UseTravelerTripsNegotiations();

  const filteredNegotiationsClient = tripsNegotiationsClient.filter((item) =>
    allowedStatuses.includes(item.trip_status),
  );

  const filteredNegotiationsTraveler = tripsNegotiationsTraveler.filter(
    (item) => allowedStatuses.includes(item.trip_status),
  );

  async function finalizar() {
    try {
      const params = new URLSearchParams(window.location.search);

      const sessionId = params.get("verificationSessionId");

      if (!sessionId) {
        console.log("Sem session id");
        return;
      }

      const response = await fetch(
        `${API_URL}/api/auth/kyc/return/?session_id=${sessionId}`,
      );

      const data = await response.json();

      console.log("RETORNO KYC:", data);

      if (data.return_to === "/payment-client") {
        const item = filteredNegotiationsClient.find(
          (negotiation) =>
            negotiation.serie_trip_negotiations ===
            data.serie_trip_negotiations,
        );

        if (item) {
          navigate("/payment-client", {
            state: {
              item,
              from: "dashboard",
            },
          });
        } else {
          console.log("Negociação não encontrada.");
        }
      }

      if (data.return_to === "/payment-traveler") {
        const item = filteredNegotiationsTraveler.find(
          (negotiation) =>
            negotiation.serie_trip_negotiations ===
            data.serie_trip_negotiations,
        );

        if (item) {
          navigate("/payment-traveler", {
            state: {
              item,
              from: "dashboard",
            },
          });
        } else {
          console.log("Negociação não encontrada.");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (loadingClient || loadingTraveler) {
      return;
    }

    finalizar();
  }, [
    loadingClient,
    loadingTraveler,
    tripsNegotiationsClient,
    tripsNegotiationsTraveler,
  ]);

  return (
    <div
      style={{
        padding: 24,
        textAlign: "center",
      }}
    >
      <h2>Finalizando verificação...</h2>
      <p>Estamos confirmando seu status.</p>
    </div>
  );
}
